export const tid = {
  // layout
  topnav: "top-nav",
  brandLink: "brand-link",
  browseLink: "browse-link",
  askLink: "ask-link",
  loginButton: "login-button",
  logoutButton: "logout-button",

  // home
  homePage: "home-page",
  homeQuestionInput: "home-question-input",
  homeCharCount: "home-char-count",
  homeSubmit: "home-submit",
  homeLoading: "home-loading",
  homeVoiceButton: "home-voice-button",
  homeImageUrlInput: "home-image-url-input",
  homeAddImageUrlButton: "home-add-image-url-button",
  homeLocationInput: "home-location-input",

  // browse
  browsePage: "browse-page",
  browseFilterAll: "browse-filter-all",
  browseFilterUnanswered: "browse-filter-unanswered",
  browseFilterDiscussed: "browse-filter-discussed",
  browseList: "browse-list",
  browseQuestionCard: (slug) => `browse-question-card-${slug}`,
  browseLoadMore: "browse-load-more",

  // question
  questionPage: "question-page",
  questionTitle: "question-title",
  questionMeta: "question-meta",
  aiSection: "ai-section",
  aiContent: "ai-content",
  communitySection: "community-section",
  loginToAnswerCta: "login-to-answer-cta",

  // editor
  answerEditor: "answer-editor",
  answerCharCount: "answer-char-count",
  postAnswerButton: "post-answer-button",
  cancelAnswerButton: "cancel-answer-button",
  answerVoiceButton: "answer-voice-button",
  answerImageUrlInput: "answer-image-url-input",
  answerAddImageUrlButton: "answer-add-image-url-button",

  // answer cards
  answerCard: (id) => `answer-card-${id}`,
  replyButton: (id) => `reply-button-${id}`,
  replyEditor: (id) => `reply-editor-${id}`,
  replyVoiceButton: (id) => `reply-voice-button-${id}`,
  replyImageUrlInput: (id) => `reply-image-url-input-${id}`,
  replyAddImageUrlButton: (id) => `reply-add-image-url-button-${id}`,
  postReplyButton: (id) => `post-reply-button-${id}`,
  voteUp: (id) => `vote-up-${id}`,
  voteDown: (id) => `vote-down-${id}`,
  voteScore: (id) => `vote-score-${id}`,
  reportButton: (id) => `report-button-${id}`,

  // report dialog
  reportDialog: "report-dialog",
  reportReasonSelect: "report-reason-select",
  reportDetailsInput: "report-details-input",
  reportSubmit: "report-submit",

  // auth
  authCallbackPage: "auth-callback-page",
  dashboardPage: "dashboard-page",

  // legal
  termsPage: "terms-page",
  privacyPage: "privacy-page",
};
